module.exports = __webpack_public_path__ + "img/thumb_01.3f977e83.jpg";